import React from 'react';
import Layout from "../../../components/mobile/Layout/layoutmobile";

import './css/termsofuse.css';
const Sudungthongtin=()=> {
const Handleclick =()=>{
    window.history.back();
}
  return (
   <Layout>
        <div className="container">
        <div className="header row d-flex pdy-10 mgx-0 mgt-10">
            <div className="col-1 in-f" onClick={Handleclick}>
                <i className="fa-solid fa fa-chevron-left"></i>
            </div>
            <div className="col-10 flex-center">
                <span className="text_14 font_700">Sử dụng thông tin</span>
            </div>
            <div className="col-1"></div>
        </div>
        {/* <h1 className='d-none'>Sử dụng thông tin</h1> */}
        <div className='container page-builder-ltr'>
        <div className='container-page-footer'>
               
               <center><h1 class="title">CHÍNH SÁCH QUYỀN RIÊNG TƯ VÀ BẢO MẬT THÔNG TIN</h1></center> 
          <div class="box--parent">
            <h2 class="title--2">I. Điều khoản chung</h2>
            <p>
              1. Chính sách Quyền riêng tư này quy định và điều chỉnh việc Chúng tôi, <strong>CÔNG TY CỔ PHẦN BIBOMART TM</strong>, xử lý dữ liệu cá nhân của bạn theo quy định của pháp luật. Chúng tôi có thể chia sẻ dữ
              liệu cá nhân của bạn với công ty mẹ, công ty con, công ty liên kết, chi nhánh, văn phòng đại diện của Chúng tôi và tiến hành các hoạt động xử lý dữ liệu với tư cách là bên kiểm soát hoặc
              đồng kiểm soát cho các mục đích được nêu tại Chính sách Quyền riêng tư và Bảo mật Thông tin này (sau đây gọi tắt là “<strong>Chính sách Quyền riêng tư</strong>”). Chúng tôi nghiêm túc thực hiện mọi nghĩa vụ
              liên quan đến bảo mật thông tin theo các quy định của pháp luật và cam kết tôn trọng quyền riêng tư của tất cả người dùng đối với Website và các sản phẩm - dịch vụ của Chúng tôi (sau đây gọi
              chung là “<strong>Nền tảng BiboMart</strong>”)
            </p>
            <p>
              2. Chính sách Quyền riêng tư này giúp bạn hiểu được cách thức Chúng tôi thu thập, sử dụng, tiết lộ và/hoặc xử lý dữ liệu cá nhân của bạn và tổ chức của bạn (sau đây gọi chung là “<strong>Dữ Liệu</strong>”)
              mà bạn đã cung cấp cho Chúng tôi và/hoặc được lưu trữ.
            </p>
            <p>3. Trong phạm vi xử lý Dữ Liệu theo Chính sách Quyền riêng tư này, Chúng tôi là Bên Kiểm soát và/hoặc là Bên Kiểm soát và Xử lý dữ liệu cá nhân.</p>
            <p>
              4. Bằng việc sử dụng, truy cập Nền tảng BiboMart, bạn xác nhận và đồng ý rằng bạn chấp nhận các điều kiện, điều khoản được mô tả tại Chính sách Quyền riêng tư này. Theo đó, bạn xác nhận bạn
              đã biết rõ và đồng ý để Chúng tôi thu thập, sử dụng, tiết lộ và/hoặc xử lý Dữ Liệu theo quy định tại Chính sách Quyền riêng tư này. NẾU BẠN KHÔNG ĐỒNG Ý VỚI BẤT KỲ NỘI DUNG NÀO TẠI CHÍNH
              SÁCH QUYỀN RIÊNG TƯ NÀY, VUI LÒNG KHÔNG SỬ DỤNG, TRUY CẬP CÁC SẢN PHẨM - DỊCH VỤ HOẶC WEBSITE CỦA CHÚNG TÔI.
            </p>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">II.DỮ LIỆU MÀ CHÚNG TÔI THU THẬP</h2>
            <p>
              Chúng tôi xử lý Dữ Liệu cũng có thể phụ thuộc vào tính năng, nghiệp vụ hoặc trải nghiệm cụ thể mà bạn sử dụng, vị trí địa lý của bạn và quy định pháp luật hiện hành. Dữ Liệu mà Chúng tôi thu
              thập hoặc nhận được về bạn tùy thuộc vào hoạt động tương tác của bạn với Chúng tôi, cách bạn cài đặt cấu hình và tài khoản, có thể bao gồm:
            </p>
    
            <div class="box--child">
              <h3 class="title--3">1. Dữ liệu cá nhân</h3>
              <p>
                Dữ liệu cá nhân là thông tin dưới dạng ký hiệu, chữ viết, chữ số, hình ảnh, âm thanh hoặc dạng tương tự trên môi trường điện tử gắn liền với một con người cụ thể hoặc giúp xác định một con
                người cụ thể. Dữ liệu cá nhân bao gồm dữ liệu cá nhân cơ bản và dữ liệu cá nhân nhạy cảm.
              </p>
              <h4 class="title--4 text--italic">1.1. Dữ liệu cá nhân cơ bản gồm:</h4>
              <ul>
                <li><span>a. Họ, chữ đệm và tên khai sinh, tên gọi khác (nếu có);</span></li>
                <li><span>b. Ngày, tháng, năm sinh;</span></li>
                <li><span>c. Giới tính; </span></li>
                <li><span>d. Thông tin cư trú: Địa chỉ thường trú, tạm trú; Nơi ở hiện tại; Quê quán; Địa chỉ liên hệ; </span></li>
                <li><span>e. Quốc tịch; </span></li>
                <li><span>f. Hình ảnh của cá nhân;</span></li>
                <li><span>g. Số điện thoại, số chứng minh nhân dân, số định danh cá nhân, số hộ chiếu, mã số thuế cá nhân;</span></li>
                <li><span>h. Tình trạng hôn nhân;</span></li>
                <li><span>i. Thông tin về mối quan hệ gia đình (cha mẹ, con cái);</span></li>
                <li><span>j. Địa chỉ email;</span></li>
                <li><span>k. Thông tin về lịch sử học tập, làm việc (bao gồm các tài liệu tham khảo); </span></li>
                <li><span>l. Thông tin thanh toán (số tài khoản ngân hàng, số thẻ tín dụng và bất kỳ chi tiết thanh toán nào khác); </span></li>
                <li><span>m. Thông tin tài khoản: ID và mật khẩu, thông tin đơn hàng, chi tiết về sản phẩm, dịch vụ mà bạn đã mua trên Website; </span></li>
                <li>
                  <span
                    >n. Dữ liệu kỹ thuật như địa chỉ giao thức trực tuyến (Internet Protocol - IP), dữ liệu đăng nhập, loại và phiên bản trình duyệt, cài đặt múi giờ và vị trí, loại và phiên bản trình cắm
                    trình duyệt (plug-in browser), hệ điều hành và nền tảng, mã nhận dạng thiết bị di động quốc tế, nhận dạng thiết bị và các thông tin và công nghệ khác trên các thiết bị bạn sử dụng để
                    truy cập Nền tảng BiboMart;
                  </span>
                </li>
                <li><span>o. Các thông tin, dữ liệu khác do bạn chủ động cung cấp thông qua Nền tảng BiboMart trong quá trình sử dụng dịch vụ (sở thích, phản hồi, trả lời khảo sát, …). </span></li>
              </ul>
    
              <h4 class="title--4 text--italic">1.2. Dữ liệu cá nhân nhạy cảm gồm:</h4>
              <ul>
                <li><span>a. Các thông tin về dân tộc, tôn giáo, đảng phái chính trị mà bạn tham gia (nếu có); </span></li>
                <li><span>b. Tình trạng sức khỏe và đời tư được ghi trong hồ sơ bệnh án, không bao gồm thông tin về nhóm máu (nếu có);</span></li>
                <li><span>c. Các thông tin về lý lịch tư pháp do bạn cung cấp (nếu có);</span></li>
                <li><span>d. Các thông tin về mức thu nhập của bạn (nếu có); </span></li>
                <li>
                  <span
                    >e. Dữ liệu sinh trắc học của bạn và người khác (giọng nói, khuôn mặt, vân tay, …) tồn tại trong tệp tin hình ảnh, video do bạn đăng trên Website; thông qua các cuộc gọi được thu âm
                    (nếu có); hoặc khi bạn sử dụng chức năng tìm kiếm bằng giọng nói của Chúng tôi;
                  </span>
                </li>
                <li><span>f. Dữ liệu về vị trí cá nhân được xác định thông qua dịch vụ định vị, không bao gồm việc bạn chia sẻ dưới dạng hình ảnh, video bằng cách đăng tải trên Website. </span></li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">2. Dữ liệu trình duyệt</h3>
              <p>
                2.1. Dữ Liệu được tạo lập/trích xuất từ hoặc liên quan đến hệ thống kỹ thuật (gồm: thiết bị, hệ điều hành, trình duyệt, địa chỉ IP, …) được kể đến như: ngôn ngữ cài đặt, thời gian truy cập
                Nền tảng BiboMart, phiên bản trình duyệt, tên tài khoản, mật khẩu, các loại dữ liệu, thông tin khác có liên quan.
              </p>
              <p>
                2.2. Dữ Liệu được tạo lập/trích xuất liên quan đến xu hướng quan tâm của bạn: thông tin quảng cáo, dữ liệu cookies, clickstream, lịch sử trình duyệt, cách hành xử với các thông tin tiếp
                thị trực tiếp và các loại dữ liệu, thông tin khác có liên quan.
              </p>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">3. Cơ sở dữ liệu người dùng</h3>
              <p>
                Khi bạn truy cập, đăng ký tài khoản, sử dụng Nền tảng BiboMart và tạo cơ sở dữ liệu của riêng bạn (“<strong>Tài Khoản</strong>”), mọi thông tin, nội dung bạn gửi hoặc tải lên Tài Khoản là
                của riêng bạn và do bạn nắm quyền kiểm soát. Chúng tôi không thể truy cập hay thực hiện bất kỳ hành động nào gây ảnh hưởng tới dữ liệu trên Tài Khoản.
              </p>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">4. Liên kết tài khoản mạng xã hội</h3>
              <p>
                Nếu bạn đăng ký tài khoản trên Website của Chúng tôi bằng tài khoản mạng xã hội của bạn (“<strong>Tài khoản MXH</strong>”) hoặc liên kết tài khoản của bạn với Tài khoản MXH hoặc chia sẻ
                thông tin trên các nền tảng mạng xã hội hoặc sử dụng một số tính năng phương tiện truyền thông khác của Chúng tôi, Chúng tôi có quyền truy cập Dữ Liệu mà bạn đã cung cấp một cách tự nguyên
                cho nhà cung cấp dịch vụ Tài khoản Mạng Xã hội theo các chính sách của các nhà cung cấp dịch vụ này. Dữ Liệu này sẽ được Chúng tôi quản lý, xử lý và sử dụng theo các quy định của Chính
                sách Quyền riêng tư này tại mọi thời điểm.
              </p>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">5. Cookies</h3>
              <p>
                Cookie được sử dụng để cho phép Chúng tôi hoặc các nhà cung cấp dịch vụ được cho phép và các đối tác quảng cáo của Chúng tôi thu thập hoặc chia sẻ thông tin liên quan đến việc sử dụng của
                bạn đối với sản phẩm, dịch vụ của Chúng tôi hoặc Nền tảng BiboMart. Các tính năng này sẽ giúp Chúng tôi cải thiện sản phẩm, dịch vụ và Nền tảng BiboMart mà Chúng tôi cung cấp cũng như mang
                đến các trải nghiệm tốt hơn khi bạn tương tác với Chúng tôi.
              </p>
    
              <p>
                5.1. Cookies là các mã danh định được máy chủ của Chúng tôi gửi tới máy tính hoặc thiết bị di động của bạn khi truy cập vào Nền tảng BiboMart. Chúng tôi có thể liên kết thông tin cookie
                với Dữ Liệu. Cookie cũng liên kết với thông tin về những nội dung bạn đã chọn để mua sắm và các trang web mà bạn đã ghé thăm. Thông tin này được sử dụng để theo dõi giỏ hàng, để chuyển tải
                nội dung phù hợp với sở thích của bạn, cho phép các đối tác cung cấp dịch vụ quảng cáo cung cấp dịch vụ quảng cáo trên các trang thông qua mạng Internet và để thực hiện phân tích dữ liệu
                và hoặc theo dõi việc sử dụng sản phẩm, dịch vụ của Chúng tôi.
              </p>
    
              <p>
                5.2. Chúng tôi cũng sử dụng các Dịch vụ của bên thứ ba - Google Analytics, người đã đặt và sử dụng cookie của riêng họ để xác định khách truy cập và cung cấp Dịch vụ theo ngữ cảnh của
                riêng họ.
              </p>
            </div>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">III. MỤC ĐÍCH THU THẬP DỮ LIỆU</h2>
            <p>1. Chúng tôi có thể sử dụng Dữ Liệu theo một số cách sau đây hoặc theo cách khác được mô tả tại thời điểm thu thập dữ liệu cá nhân nhằm mục đích, bao gồm nhưng không giới hạn bởi:</p>
            <div class="box--child">
              <h3 class="title--3 text--italic">1.1. Vận hành Nền tảng BiboMart và cung cấp sản phẩm - dịch vụ</h3>
              <ul>
                <li><span>a. Quản lý, điều hành, cung cấp và/hoặc quản lý việc bạn sử dụng sản phẩm - dịch vụ và/hoặc truy cập Nền tảng BiboMart;</span></li>
                <li>
                  <span
                    >b. Xử lý, hoàn tất, giải quyết đơn hàng của bạn thực hiện qua Website và/hoặc đáp ứng các yêu cầu của bạn đối với các sản phẩm và dịch vụ nhất định và thông báo cho bạn về các vấn đề
                    dịch vụ và các hoạt động tài khoản bất thường;</span
                  >
                </li>
                <li>
                  <span
                    >c. Kết nối và trao đổi với bạn. Xử lý các câu hỏi, phản hồi, yêu cầu do bạn gửi tới và các khiếu nại của bạn trong quá trình sử dụng sản phẩm - dịch vụ, tương tác với Chúng tôi;
                  </span>
                </li>
                <li><span>d. Duy trì và quản lý các vấn đề kỹ thuật, công nghệ nhằm đảm bảo Nền tảng BiboMart hoạt động ổn định; </span></li>
                <li><span>e. Xác minh danh tính và đảm bảo tính bảo mật Dữ Liệu của bạn; </span></li>
                <li><span>f. Xác minh và thực hiện các giao dịch tài chính liên quan đến khoản thanh toán mà bạn thực hiện trực tuyến; </span></li>
                <li><span>g. Thực thi các Chính sách - Điều khoản của Chúng tôi hoặc bất kỳ thỏa thuận/hợp đồng nào mà Chúng tôi áp dụng;</span></li>
                <li>
                  <span
                    >h. Thông báo về những thay đổi của sản phẩm - dịch vụ trong trường hợp có sự thay đổi về chính sách quản lý của Nhà nước, quy định của pháp luật; hoặc sự biến động, thay đổi của thị
                    trường; hoặc các thay đổi, cập nhật từ Chúng tôi.
                  </span>
                </li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3 text--italic">1.2. Nghiên cứu và phát triển</h3>
              <ul>
                <li>
                  <span>
                    a. Sử dụng, phân tích, khảo sát các thông tin các tương tác và hoạt động sử dụng của bạn với Nền tảng BiboMart hoặc với một số nội dung bạn nhận được từ bên thứ ba gửi, hoặc với nội
                    dung hiển thị thông qua Nền tảng BiboMart, bao gồm nhưng không giới hạn ở việc phân tích dữ liệu để phát triển thông tin chi tiết, nhu cầu và sở thích của bạn, để đưa ra các dự đoán,
                    đề xuất và sản phẩm phù hợp hơn cho khách hàng cũng như để phát triển, cung cấp, liên tục cải tiến, nâng cấp chất lượng sản phẩm - dịch vụ, đáp ứng tốt hơn nhu cầu của khách hàng;
                  </span>
                </li>
                <li><span>b. Kiểm tra và khảo sát khác để xác thực quy mô và thành phần của đối tượng mục tiêu của chúng tôi, và hiểu được trải nghiệm của họ với Nền tảng BiboMart. </span></li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3 text--italic">1.3. Tiếp thị và quảng cáo</h3>
              <ul>
                <li>
                  <span>
                    a. Gửi đến bạn thông tin và tài liệu tiếp thị và quảng bá liên quan đến các sản phẩm và/hoặc dịch vụ (bao gồm, nhưng không giới hạn các sản phẩm và/hoặc dịch vụ của các bên thứ ba mà
                    Chúng tôi có thể hợp tác hoặc liên kết) qua các phương tiện và phương thức liên lạc khác nhau;
                  </span>
                </li>
                <li>
                  <span> b. Cung cấp các chương trình và ưu đãi khách hàng thường xuyên, đối tác cũng như các chiến dịch marketing đồng thương hiệu khác; </span>
                </li>
                <li>
                  <span>
                    c. Cá nhân hóa trải nghiệm của bạn và điều chỉnh các đề xuất, quảng cáo và ưu đãi dành cho bạn, bao gồm thông qua việc phát triển thông tin chi tiết về bạn và nhu cầu của bạn dựa trên
                    tương tác của bạn với các sản phẩm - dịch vụ và ưu đãi của Chúng tôi.
                  </span>
                </li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3 text--italic">1.4. Tuân thủ và Ngăn chặn</h3>
              <ul>
                <li><span>a. Để thiết lập, thực thi các quyền hợp pháp hoặc bảo vệ các khiếu nại pháp lý của Chúng tôi; </span></li>
                <li>
                  <span>
                    b. Đáp ứng các thủ tục pháp lý hoặc để tuân thủ hoặc theo quy định của pháp luật hiện hành, và các yêu cầu của cơ quan nhà nước có thẩm quyền hoặc yêu cầu của các cơ quan có thẩm quyền
                    hoặc khi Chúng tôi nhận thấy việc tiết lộ thông tin là cần thiết, bao gồm nhưng không giới hạn, đáp ứng các yêu cầu đáp ứng các yêu cầu công bố thông tin theo yêu cầu của bất kỳ luật
                    ràng buộc nào đối với Chúng tôi;
                  </span>
                </li>
                <li>
                  <span>
                    c. Thực hiện quy trình kiểm tra và xác minh hoặc các hoạt động sàng lọc khác tuân thủ các nghĩa vụ theo quy định pháp luật hoặc cơ quan nhà nước có thẩm quyền hoặc các thủ tục kiểm
                    soát rủi ro của Chúng tôi, có thể được pháp luật yêu cầu hoặc có thể đã được Chúng tôi áp dụng;
                  </span>
                </li>
                <li>
                  <span>
                    d. Ngăn chặn hoặc điều tra bất kỳ hoạt động gian lận thực tế hoặc bị nghi ngờ nào đối với Chính sách - Điều khoản của Chúng tôi, gian lận, các hành vi phi pháp, thiếu sót hay hành vi
                    sai trái nào, cho dù có liên quan đến việc bạn sử dụng Nền tảng BiboMart hay không, hoặc bất kỳ vấn đề nào phát sinh từ quan hệ của bạn với Chúng tôi;
                  </span>
                </li>
                <li><span>e. Tuân thủ quy định pháp luật hiện hành và các tiêu chuẩn, điều kiện có liên quan đến hoạt động kinh doanh của Chúng tôi. </span></li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3 text--italic">1.5. Bất kỳ mục đích nào khác mà Chúng tôi thông báo cho bạn tại thời điểm được bạn chấp thuận.</h3>
            </div>
    
            <p>
              2. Chúng tôi có thể truy cập, lưu trữ, xử lý và tiết lộ thông tin của bạn theo quy định của pháp luật hoặc theo lệnh của tòa án hoặc của bất kỳ cơ quan quản lý nào có thẩm quyền hoặc ngay
              khi Chúng tôi nhận thấy việc truy cập, lưu giữ hoặc tiết lộ đó là cần thiết và chính đáng nhằm:
            </p>
            <p>
              2.1. Tuân thủ các thủ tục pháp lý cần thiết; <br />
              2.2. Tuân thủ theo yêu cầu của các cơ quan quản lý nào có thẩm quyền;<br />
              2.3. Thực thi bộ Chính sách - Điều khoản của Chúng tôi; <br />
              2.4. Phản hồi bất kỳ khiếu nại nào du cho là nguy cơ hoặc đang xảy ra trên thực tế để chống lại Chúng tôi hoặc khiếu nại khác rằng bất kỳ Nội dung nào vi phạm quyền của bên thứ ba;<br />
              2.5. Đáp ứng các yêu cầu của bạn về dịch vụ khách hàng.<br />
            </p>
            <p>
              3. Chúng tôi sẽ thông báo về việc xử lý Dữ Liệu theo Mục 3.2 nêu trên cho bạn biết tại thời điểm xin chấp thuận từ bạn, trừ phi việc xử lý dữ liệu áp dụng mà không có sự đồng ý của bạn là
              được phép theo các quy định của pháp luật về bảo vệ bí mật thông tin cá nhân hoặc pháp luật có quy định khác đi.
            </p>
          </div>
    
          <div class="box-parent">
            <h2 class="title--2">IV. CÁCH THỨC THU THẬP DỮ LIỆU</h2>
            <div class="box--child">
              <h3 class="title--3">1. Xử lý Dữ Liệu</h3>
              <p>
                Xử lý Dữ Liệu là một hoặc nhiều hoạt động tác động tới Dữ Liệu như: thu thập, ghi, phân tích, xác nhận, lưu trữ, chỉnh sửa, công khai, kết hợp, truy cập, truy xuất, thu hồi, mã hoá, giải
                mã, sao chép, chia sẻ, truyền đạt, cung cấp, chuyển giao, xoá bỏ, huỷ bỏ hoặc các hành động khác có liên quan.
              </p>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">2. Thu thập Dữ Liệu trực tiếp từ bạn</h3>
              <ul>
                <li><span>2.1. Khi bạn đăng ký tài khoản trên Website của Chúng tôi; sử dụng/mua bất kỳ sản phẩm - dịch vụ nào do Chúng tôi cung cấp;</span></li>
                <li><span>2.2. Khi bạn truy cập các kênh truyền thông bất kỳ của Chúng tôi hoặc sử dụng bất kỳ tính năng, tài nguyên nào có sẵn trên hoặc thông qua các kênh truyền thông này;</span></li>
                <li><span>2.3. Khi bạn tải xuống, truy cập, sử dụng ứng dụng của Chúng tôi trên các thiết bị di động; </span></li>
                <li>
                  <span>
                    2.4. Khi bạn có tương tác với Chúng tôi thông qua việc liên hệ, trao đổi (trực tiếp, qua email, điện thoại, trực tuyến hay bất kỳ phương thức nào khác); đăng ký nhận ấn phẩm, tài liệu
                    tiếp thị của Chúng tôi; tham gia các chương trình khuyến mãi, khảo sát;
                  </span>
                </li>
                <li>
                  <span>
                    2.5. Thu thập tự động bao gồm địa chỉ IP, URL giới thiệu, hệ điều hành, thông tin trình duyệt (các loại cookies, plug-in hoặc trình kết nối mạng xã hội của bên thứ ba, thông tin vị trí
                    hoặc siêu dữ liệu khác được cung cấp bởi một thiết bị, …).
                  </span>
                </li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">3. Thu thập qua bên thứ ba</h3>
              <p>Các bên thứ ba sẽ bao gồm các nhà cung cấp dịch vụ, các bên liên kết và các bên thứ ba có liên quan đến hoạt động kinh doanh của Chúng tôi; các bên có liên quan với bạn.</p>
            </div>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">V. LƯU TRỮ VÀ XÓA DỮ LIỆU</h2>
            <div class="box--child">
              <h3 class="title--3">1. Truy cập và sửa Dữ Liệu</h3>
              <p>Bạn có quyền truy cập để xem và tự chỉnh sửa các loại dữ liệu cá nhân của mình bất kỳ lúc nào bằng cách điều chỉnh, thay đổi thông tin đó trực tiếp hoặc gián tiếp.</p>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">2. Lưu trữ Dữ Liệu</h3>
              <p>
                2.1. Dữ Liệu sẽ được lưu trữ kể từ thời điểm bạn tương tác với Nền tảng BiboMart và các trang truyền thông hoặc kênh liên hệ của Chúng tôi cho đến khi bạn có yêu cầu huỷ bỏ hoặc tự thực
                hiện xóa Dữ Liệu và/hoặc theo các quy định của pháp luật tại từng thời điểm. Trong các trường hợp còn lại, Dữ Liệu được bảo mật trên máy chủ của BiboMart.
              </p>
              <p>
                2.2. Chúng tôi sẽ lưu trữ Dữ Liệu trong một khoảng thời gian hợp lý tuân theo các quy định của pháp luật về bảo vệ bí mật thông tin cá nhân và/hoặc các quy định pháp luật hiện hành khác
                trong suốt quá trình bạn sử dụng sản phẩm - dịch vụ hoặc bạn vẫn còn tương tác với Nền tảng BiboMart. Dữ Liệu sẽ tiếp tục được lưu trữ trong khoảng thời gian hợp lý trong trường hợp Chúng
                tôi đánh giá rằng:
              </p>
              <ul>
                <li><span>a. Việc lưu trữ không còn cần thiết để thực hiện mục đích thu thập Dữ Liệu đó nữa; </span></li>
                <li><span>b. Việc lưu trữ không còn cần thiết cho bất kỳ mục đích hợp pháp hay mục đích kinh doanh nào; </span></li>
                <li><span>c. Không còn các lợi ích hợp pháp nào khác để tiếp tục lưu trữ Dữ Liệu này. </span></li>
              </ul>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">3. Xoá, huỷ Dữ Liệu</h3>
              <p>
                Chúng tôi bảo lưu quyền từ chối xóa, tiêu hủy dữ liệu trong trường hợp yêu cầu của bạn không phù hợp với quy định pháp luật hiện hành, hoặc mặc dù phù hợp nhưng thuộc trường hợp Chúng tôi
                không được xóa, tiêu hủy theo quy định của pháp luật hoặc các lý do hợp lý khác về kỹ thuật hoặc kinh doanh. Tùy thuộc vào quy định của pháp luật, Chúng tôi có thể tiêu hủy dữ liệu cá nhân
                của bạn một cách an toàn mà không cần thông báo trước cho bạn.
              </p>
            </div>
    
            <div class="box--child">
              <h3 class="title--3">4. Rút lại sự đồng ý, hạn chế và phản đối xử lý Dữ Liệu</h3>
              <p>
                Bạn có thể <strong class="text--underline">rút lại sự đồng</strong> ý cho phép, yêu cầu hạn chế, phản đối trong việc xử lý Dữ Liệu của bạn mà Chúng tôi đang lưu giữ hoặc kiểm soát bằng
                cách gửi yêu cầu cho Chúng tôi qua các phương thức liên hệ tại Chính sách Quyền riêng tư này. Chúng tôi sẽ xử lý các yêu cầu này theo Chính sách Quyền riêng tư cũng như quy định pháp luật
                có liên quan. Tuy nhiên, việc bạn rút lại sự cho phép, yêu cầu hạn chế, phản đối xử lý Dữ Liệu có thể đồng nghĩa với việc Chúng tôi sẽ không thể tiếp tục cung cấp các sản phẩm - dịch vụ
                đến bạn hoặc chấm dứt các hợp đồng đã được ký kết với bạn. Trong trường hợp này, Chúng tôi được miễn trừ khỏi toàn bộ trách nhiệm phải thực hiện với bạn do không cung cấp sản phẩm - dịch
                vụ hoặc chấm dứt thực hiện hợp đồng đã giao kết. Mọi quyền lợi và các biện pháp khắc phục của Chúng tôi được bảo lưu theo các thỏa thuận khác có liên quan được công khai tại Website.
              </p>
            </div>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">VI. CHUYỂN DỮ LIỆU RA NƯỚC NGOÀI</h2>
            <p>
              1. Dữ Liệu của bạn có thể được lưu và xử lý tổng thể hoặc từng phần ở Việt Nam hoặc nước ngoài. Việc truy cập, sử dụng Nền tảng BiboMart từ các địa điểm nằm ngoài lãnh thổ Việt Nam được hiểu
              rằng bạn đồng ý chuyển Dữ Liệu của mình ra ngoài phạm vi quốc gia/vùng lãnh thổ dó và gửi tới Việt Nam.
            </p>
    
            <p>
              2. Dữ Liệu của bạn có thể được chuyển ra nước ngoài, lưu trữ hoặc xử lý bên ngoài quốc gia của bạn cho một hoặc nhiều mục đích. Chúng tôi chỉ chuyển Dữ Liệu của bạn ra nước ngoài khi nhận
              thấy phù hợp với quy định của pháp luật về bảo vệ dữ liệu cá nhân.
            </p>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">VII. DỮ LIỆU CỦA TRẺ EM</h2>
            <p>
              Chúng tôi thu thập và xử lý dữ liệu trên nguyên tắc bảo vệ quyền và lợi ích tốt nhất của trẻ em. Nền tảng BiboMart của Chúng tôi không dành cho trẻ em dưới 16 tuổi. Chúng tôi không cố tình
              thu thập hay lưu giữ bất kỳ Dữ Liệu hay thông tin không nhận dạng cá nhân nào của bất kỳ ai dưới 16 tuổi. Bố/mẹ hoặc người giám hộ của trẻ em dưới 16 tuổi vui lòng giám sát và đảm bảo thông
              tin cá nhân của trẻ dưới 16 tuổi mà mình đang giám hộ không đăng tải thông tin cá nhân trên Nền tảng BiboMart. Trong trường hợp Chúng tôi nhận được Dữ Liệu của trẻ em dưới 16 tuổi do bố/mẹ
              hoặc người giám hộ cung cấp, có nghĩa là bố/mẹ hoặc người giám hộ đồng ý với việc xử lý Dữ Liệu của trẻ em dưới 16 tuổi và chịu sự điều chỉnh của Chính sách Quyền riêng tư này thay mặt cho
              người được giám hộ. Chúng tôi sẽ chủ động xóa/gỡ bỏ hoàn toàn mọi tài khoản được tạo lập bởi hoặc các Dữ Liệu được cho là do trẻ em dưới 16 tuổi cung cấp.
            </p>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">VIII. GIỚI HẠN TRÁCH NHIỆM VỀ NGHĨA VỤ BẢO MẬT THÔNG TIN</h2>
            <p>
              1. Chúng tôi cam kết nỗ lực tối đa trong khả năng của mình về nhân lực, công nghệ và các yếu tố khác để bảo mật Dữ Liệu của bạn một cách tốt nhất có thể. Tuy nhiên, Chúng tôi không thể cam
              kết điều này trong trường hợp xảy ra sự kiện bất kháng bao gồm nhưng không giới hạn bởi thiên tai, dịch bệnh, mất điện diện rộng, tin tặc, virus máy tính tấn công, gián đoạn đường truyền
              Internet, đứt cáp viễn thông, …
            </p>
            <p>
              2. Nhằm mang đến những trải nghiệm tốt hơn cho bạn cũng như để thuận tiện cho việc truy cập thông tin của bạn, Nền tảng BiboMart của Chúng tôi có liên kết đến các website, ứng dụng và/hoặc
              các dịch vụ khác (bao gồm các ứng dụng do bên thứ ba vận hành). Những trang được liên kết này có các chính sách về quyền riêng tư cũng như các biện pháp bảo mật độc lập và Chúng tôi không
              thể tiếp cận, kiểm soát được các phương pháp bảo vệ quyền riêng tư và thu thập dữ liệu của họ. Chúng tôi KHÔNG chịu bất kỳ trách nhiệm nào phát sinh đối với nội dung, biện pháp bảo mật hoặc
              sự thiếu biện pháp bảo mật và các hoạt động của những trang liên kết này. Do đó, Chúng tôi khuyến khích bạn tìm hiểu kỹ các chính sách bảo mật của những trang liên kết này trước khi sử dụng.
            </p>
          </div>
    
          <div class="box--parent">
            <h2 class="title--2">IX. CẬP NHẬT NỘI DUNG CHÍNH SÁCH</h2>
            <p>
              1. Chúng tôi bảo lưu quyền điều chỉnh, thay đổi, bổ sung nội dung Chính sách Bảo mật này bất kỳ lúc nào để đáp ứng sự phát triển về kỹ thuật và chính sách kinh doanh của Chúng tôi nhưng vẫn
              đảm bảo việc tuân thủ quy định của pháp luật hiện hành. Việc điều chỉnh, thay đổi, bổ sung sẽ được thông báo đến tất cả người dùng trên Nền tảng BiboMart của Chúng tôi.
            </p>
            <p>
              2. Việc thay đổi Chính sách Quyền riêng tư này sẽ được Chúng tôi sẽ thông báo cho bạn bao gồm cả thông qua việc đăng tải những thay đổi đó hoặc Chính sách Quyền riêng tư sửa đổi trên Nền
              tảng BiboMart. Trong phạm vi pháp luật cho phép, việc tiếp tục sử dụng các sản phẩm - dịch vụ của chúng tôi hoặc truy cập Nền Tảng BiboMart được hiểu rằng bạn đồng ý với các thay đổi trong
              Chính sách Quyền riêng tư này.
            </p>
          </div>
    
          <div class="box--title">
            <h2 class="title--2">X. HIỆU LỰC</h2>
            <p>
              1. Chính sách Quyền riêng tư được áp dụng cùng với các thông báo, điều khoản hợp đồng, điều khoản chấp thuận khác áp dụng liên quan đến việc Chúng tôi thu thập, lưu trữ, sử dụng, tiết lộ
              và/hoặc xử lý Dữ Liệu và không nhằm ghi đè những thông báo hoặc các điều khoản đó trừ khi có tuyên bố khác đi.
            </p>
    
            <p>2. Chính sách Quyền riêng tư này chính thức có hiệu lực từ ngày 03/07/2024 và thay thế cho các phiên bản đã được ban hành trước đây.</p>
          </div>
    
        </div>
            
        </div>

        <div className="footer text_13 font_500">
            <div className="row">
                <div className="col-12">
                    <div className="card card-border flex-center-col">
                        <span className="">Mọi thắc mắc, vui lòng liên hệ:</span>
                        <span className="font_700 color_red">P. Chăm sóc Khách hàng</span>
                        <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                        <span className="">Hotline: 1800 6886 (Miễn phí)</span>
                        <span className="">Email: cskh@bibomart.com.vn</span>
                    </div>
                </div>
            </div>
            <div className="row mgt-30">
                <div className="col-12 flex-center-col">
                    <span className="font_700 color_red">Công ty Cổ phần Bibo Mart TM</span>
                    <ul className="mgt-10">
                        <li>Trụ sở: 120 Trần Duy Hưng, Q. Cầu Giấy, TP. Hà Nội.</li>
                        <li>Văn phòng Miền Bắc: Toà nhà Handico, Phạm Hùng, P. Mễ Trì, Q. Nam Từ Liêm, TP. Hà Nội. Số điện thoại: (024) 7309 1168</li>
                        <li>Văn phòng Miền Nam: Tầng 3, số 2A Nguyễn Oanh, P.7, Q. Gò Vấp, TP. Hồ Chí Minh.</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
   </Layout>
  )
}
export default Sudungthongtin;